<template>
	<b-modal
          id="createTaskTemplateModal"
          ref="createTaskTemplateModal"
          :title="title"
          size="lg"
		:centered="true"
		:scrollable="true"
		@close="close">

		<template v-slot:default="{}">

			<b-container class="modal-body-lg">

				<b-form 
					@submit="submitForm">

					<b-form-row>
						<b-col>
							<b-form-group
								id="template-name-group"
								label="Name"
								label-for="template-name"
								:state="templateValidation.name"
								invalid-feedback="A name is required.">

								<b-form-input
                                             id="name"
                                             v-model="localTaskTemplate.name"
                                             type="text"
									placeholder="Name your template"
                                             validated="true"
                                             :state="templateValidation.name"
                                             
                                        />

							</b-form-group>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-col>
							<b-form-group
								id="template-description-group"
								label="Description"
								label-for="template-description"
								:state="templateValidation.description"
								invalid-feedback="A description is required.">

								<b-form-textarea
                                             id="template-description"
                                             v-model="localTaskTemplate.description"
                                             rows="3"
									max-rows="10"
									placeholder="Describe your template"
                                             validated="true"
                                             :state="templateValidation.description"
                                             
                                        />

							</b-form-group>
						</b-col>
					</b-form-row>
					
					<b-form-row>

						<b-col>

							<b-list-group>

								<b-list-group-item 
									v-for="(task, taskIndex) in tasksForList" 
									:key="taskIndex"
									:variant="task.variant">

									<b-form-group
										:id="'template-task-title-group_' + taskIndex"
										label="Title"
										:label-for="'task-title_' + taskIndex"
										:state="templateValidation['title_'+ taskIndex]"
										invalid-feedback="A title is required.">

										<b-form-input
											:id="'task-title_' + taskIndex"
											v-model='task.title'
											type="text"
											placeholder=""
											validated="true"
											:state="templateValidation['title_'+ taskIndex]"
											
										/>

									</b-form-group>

									<b-form-group
										:id="'template-task-notes-group_' + taskIndex"
										label="Notes"
										:label-for="'task-notes_' + taskIndex"
										:state="templateValidation['notes_'+ taskIndex]"
										invalid-feedback="A description is required.">

										<b-form-textarea
											:id="'task-notes_' + taskIndex"
											v-model="task.notes"
											rows="3"
											max-rows="10"
											placeholder="Describe this task.  Markdown is supported."
											validated="true"
											:state="templateValidation['notes_'+ taskIndex]"
											
										/>

									</b-form-group>

									<center>


											<b-icon
												icon="trash"
												id="remove-task-from-template-icon"
												variant="danger"
												style="width:20px; height:20px;"
												@click="removeTask(task.index, task.parentIndex, task.childIndex)"
											/>

											<b-tooltip 
												target="remove-task-from-template-icon"
												triggers="hover"
												variant="danger">
												Remove this task from the template.
											</b-tooltip>
											
											<b-icon
												icon="plus"
												id="add-task-to-template-icon"
												variant="success"
												class="ml-1"
												style="width:20px; height:20px;"
												@click="addTask(task.index, task.parentIndex, task.childIndex)"
											/>

											<b-tooltip 
												target="add-task-to-template-icon"
												triggers="hover"
												variant="success">
												Add a task to this template.
											</b-tooltip>
											
											<b-icon
												v-if="task.variant == 'primary'"
												icon="file-plus"
												id="add-child-to-template-icon"
												variant="success"
												class="ml-1"
												style="width:20px; height:20px;"
												@click="addChildTask(task.index)"
											/>

											<b-tooltip 
												v-if="task.variant == 'primary'"
												target="add-child-to-template-icon"
												triggers="hover"
												variant="success">
												Add a child to {{task.title || 'this task'}}
											</b-tooltip>

									</center>

									<!-- <center>
										Index: {{task.index}},
										Parent Index: {{task.parentIndex}},
										Child Index: {{task.childIndex}}
									</center> -->

								</b-list-group-item>
							</b-list-group>

						</b-col>

					</b-form-row>
				
				

				</b-form>

				

				

			</b-container>

		</template>

		<template v-slot:modal-footer="{ close }">
			
			<b-button size="md" variant="warning" @click="close()">
			Close
			</b-button>
			
			<b-button 
				v-if="editMode" 
				size="md" 
				variant="danger" 
				id="delete-template-button"
				@click="deleteTemplate()">
			Delete
			</b-button>
			
			<b-tooltip 
				v-if="editMode" 
				target="delete-template-button"
				triggers="hover"
				variant="danger">
				Remove this template from your personal gallery.  This does not affect the public gallery.
			</b-tooltip>
			
			<b-button 
				size="md" 
				id="save-template-button"
				variant="success" 
				@click="submitForm">
			Save
			</b-button>
			
			<b-tooltip 
				target="save-template-button"
				triggers="hover"
				variant="success"
				placement="topleft">
				Save this template.
			</b-tooltip>
		</template>



	</b-modal>
</template>

<script>
export default {
	name: 'TaskTemplatePopup',
    	mixins: [],
	props: {
		taskTemplate: {
			type: Object,
               required: true,
		}
	},
	data() {
		return {
			templateValidation: {
				valid: false,
				description: null,
				name: null,
			}
		}
	},
	computed: {
		editMode: {
			get() {
				if(typeof this.localTaskTemplate._id != 'undefined' && this.localTaskTemplate._id !== null) {
					return true
				} else {
					return false
				}
			}
		},
		localTaskTemplate: {
			get() {
				return this.taskTemplate
			},
			set(newValue) {
				this.taskTemplate = newValue
			}
		},
		tasksForList: {
			
			// 20201003 -- ZWS -- Flatten tasks and their children so that the list is prettier.
			
			get() {
				
				let list = []
				
				if(typeof this.localTaskTemplate.tasks != 'undefined' && this.localTaskTemplate.tasks !== null) {

					this.localTaskTemplate.tasks.forEach((task, index) => {
						let temp = task
						temp.index = index
						temp.variant = 'primary'
						list.push(temp)

						if(typeof task.children != 'undefined' && task.children !== null) {
						
							task.children.forEach((child, childIndex) => {
								let temp2 = child
								temp2.variant = 'light'
								temp2.parentIndex = index
								temp2.childIndex = childIndex
								list.push(temp2)
							})
						}

					})
				
				}
				
				

				return list
			}
		},
		title: {
			get() {
				if(this.editMode) {
					return 'Edit Template'
				} else {
					return 'Create Template'
				}
			}
		}
		
	},
	methods: {
		addChildTask(index) {

			if(!this.templateValidation.valid) {
				this.resetValidationData()
			}

			this.$emit('addChild:template', this.localTaskTemplate, index)
		},
		addTask(index, parentIndex, childIndex) {
			
			if(!this.templateValidation.valid) {
				this.resetValidationData()
			}
			
			this.$emit('addTask:template', this.localTaskTemplate, index, parentIndex, childIndex)
		},
		close() {
			
			this.resetValidationData()
			this.$emit('cancel:template')
		},
		deleteTemplate() {
			this.$emit('delete:template', this.localTaskTemplate)
		},
		resetValidationData() {
			this.templateValidation = {}
			this.$set(this.templateValidation, 'valid', true)
		},
		submitForm(event) {

			event.preventDefault()

			this.resetValidationData()

			if(typeof this.localTaskTemplate.name == 'undefined' || this.localTaskTemplate.name === null) {
				this.$set(this.templateValidation, 'valid', false)
				this.$set(this.templateValidation, 'name', false)
			}

			if(typeof this.localTaskTemplate.description == 'undefined' || this.localTaskTemplate.description === null) {
				this.$set(this.templateValidation, 'valid', false)
				this.$set(this.templateValidation, 'description', false)
			}

			let masterIndex = 0

			this.localTaskTemplate.tasks.forEach((task, index) => {
				
				if(typeof task.title == 'undefined' || task.title === null) {
					
					this.$set(this.templateValidation, 'valid', false)
					this.$set(this.templateValidation, 'title_' + masterIndex, false)

					
				
				}
				
				masterIndex++
				
				task.children.forEach((child, childIndex) => {
					
					if(typeof child.title == 'undefined' || child.title === null) {
						this.$set(this.templateValidation, 'valid', false)
						this.$set(this.templateValidation, 'title_' + masterIndex, false)
					}
					

					masterIndex++

				})

			})

			if(this.templateValidation.valid) {
				this.$emit('add:template', this.localTaskTemplate)
			}
			

		},
		removeTask(index, parentIndex, childIndex) {
			this.$emit('removeTask:template', this.localTaskTemplate, index, parentIndex, childIndex)
		},
		useTemplate() {
			this.$emit('instantiate:template', this.localTaskTemplate)
		}
	}
}
</script>